import { useApi } from '@/composables/useApi'

const api = useApi()

export function UploadFilesService() {
  this.uploadfile = function (params) {
    return new Promise((resolve, reject) => {
      try {
        api.post('/uploadfile', params)
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.delefile = function (uid) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`deleteFileuid/${uid}`)
          .then(resp => {
            resolve(resp.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
